// Call Partnerships
import { apiPublic } from '../../utils/hooks';

const postRegistrationAssociation = (newAssociation) => {
    return apiPublic()
        .post('/registration/association', newAssociation)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};
const postRegistrationUser = (newUser) => {
    return apiPublic()
        .post('/registration/create', newUser)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

export { postRegistrationAssociation, postRegistrationUser };
